
import { butter } from "~/plugins/buttercms";
import {
  invokeShopifyQuery,
  itemFilterWithProdUpgrades,
  GIFT_ADDS,
} from "@/utils/shopify";
import ProductMapMixin from "~/mixin/product-map-mixin";
import ShopifyProduct from "~/types/shopify/ShopifyProduct";
import FormatMixin from "~/mixin/format-mixin";
import ProcessLineItemsMixin from "~/mixin/process-lineitems-mixin";
import DeliveryWeekMixin from "~/mixin/delivery-week-mixin";
import Addon from "~/types/cms/Addon";

export default {
  name: "upgrade-bouquet",
  data() {
    return {
      upgradeOptions: [],
      addOnsCMS: [],
      isUpgradeSelected:
        Object.keys(this.$store.state.cartItem.upgrade).length > 0,
      selectedUpgradeTitle: this.$store.state.cartItem.upgrade?.title || "",
      hideUpgrade: false,
      eligableUpgrade: {},
      productVariant: this.$store.state.cartItem.product?.title || "",
    };
  },
  computed: {
    isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    },
    description() {
      if (this.eligableUpgrade.title) {
        return this.getUserViewDescription(
          this.eligableUpgrade.title,
          GIFT_ADDS,
          this.addOnsCMS
        );
      } else {
        return "";
      }
    },
  },
  mixins: [
    ProductMapMixin,
    ProcessLineItemsMixin,
    FormatMixin,
    DeliveryWeekMixin,
  ],
  async fetch() {
    try {
      await this.getAddonsContent();
      await this.getUpgradeProds();
    } catch (error) {
      console.error(error);
    }
  },
  created() {
    if (Object.keys(this.$store.state.cartItem.upgrade).length > 0) {
      this.isUpgradeSelected = true;
    } else {
      this.isUpgradeSelected = false;
    }
    this.$nuxt.$on("productSelected", () => {
      this.productVariant = this.$store.state.cartItem.product?.title || "";
      this.getAvailableUpgrade();
    });
  },
  mounted() {
    this.productVariant = this.$store.state.cartItem.product?.title || "";
    this.getAvailableUpgrade();
    if (
      this.$store.state.cartItem.product?.tags &&
      this.$store.state.cartItem.product?.tags.includes("centrepiece")
    ) {
      this.hideUpgrade = true;
    }
  },
  watch: {
    productVariant() {
      this.getAvailableUpgrade();
      if (
        this.$store.state.cartItem.product?.tags &&
        this.$store.state.cartItem.product?.tags.includes(
          `${this.productVariant}-hide-upgrade`
        )
      ) {
        this.hideUpgrade = true;
      }
      if (this.productVariant === "Grand") {
        this.hideUpgrade = true;
      }
    },
    upgradeOptions() {
      if (this.upgradeOptions.length > 0) {
        this.getAvailableUpgrade();
      }
    },
    eligableUpgrade() {
      if (this.eligableUpgrade.title != this.selectedUpgradeTitle) {
        this.isUpgradeSelected = false;
        this.onUpgradeSelect(this.isUpgradeSelected);
      }
      if(Object.keys(this.eligableUpgrade).length == 0) {
        this.isUpgradeSelected = false;
        this.onUpgradeSelect(this.isUpgradeSelected);
        this.hideUpgrade = true;
      }
    },
  },
  methods: {
    getAvailableUpgrade() {
      if (this.productVariant.length > 0 && this.upgradeOptions.length > 0) {
        if (
          this.productVariant.includes("Deluxe") &&
          this.$store.state.cartItem.product?.tags.includes("Luxe") &&
          this.isUpgradeAvailable("Grand")
        ) {
          this.setUpgradeOption("Grand", true);
          this.hideUpgrade = false;
        } else if (
          this.productVariant.includes("Deluxe") &&
          this.isUpgradeAvailable("Grand")
        ) {
          this.setUpgradeOption("Grand", false);
          this.hideUpgrade = false;
        } else if (
          this.productVariant.includes("Standard") &&
          this.isUpgradeAvailable("Deluxe")
        ) {
          this.setUpgradeOption("Deluxe", false);
          this.hideUpgrade = false;
        } else {
          this.hideUpgrade = true;
          this.eligableUpgrade = {};

        }
      }
    },
    isUpgradeAvailable(searchForSize) {
      let variant = this.$store.state.cartItem.product?.variants.find(
        (item) => item.title === searchForSize
      );
      if (variant) {
        return variant.availableForSale;
      }
      return false;
    },
    setUpgradeOption(type, isLuxe) {
      if (this.upgradeOptions.length > 0) {
        if (type === "Grand" && isLuxe) {
          let item = this.upgradeOptions.find(
            (upgrade) => upgrade.sku === "luxe_grand_size_upgrade"
          );
          if (item) {
            this.eligableUpgrade = item;
          }
        } else if (type === "Grand" && !isLuxe) {
          let item = this.upgradeOptions.find(
            (upgrade) => upgrade.sku === "grand_size_upgrade"
          );
          if (item) {
            this.eligableUpgrade = item;
          }
        } else if (type === "Deluxe") {
          let item = this.upgradeOptions.find(
            (upgrade) => upgrade.sku === "deluxe_size_upgrade"
          );
          if (item) {
            this.eligableUpgrade = item;
          }
        }
      }
    },
    toggleSelect() {
      this.isUpgradeSelected = !this.isUpgradeSelected;
      this.onUpgradeSelect(this.isUpgradeSelected);
    },
    onUpgradeSelect(selected) {
      let upgrade = this.eligableUpgrade || {};
      upgrade["productType"] = GIFT_ADDS;
      if (!selected) {
        this.$store.dispatch("cartItem/UPGRADE_REMOVE", upgrade);
        this.selectedUpgradeTitle = "";
      } else {
        this.$store.dispatch("cartItem/UPGRADE_ADD", upgrade);
        this.selectedUpgradeTitle = upgrade.title;
      }
    },
    getImages(title, productType, cmsData) {
      const cmsProduct = cmsData.filter((product) =>
        product.productName.includes(title)
      )[0];
      return cmsProduct
        ? this.isMobile
          ? cmsProduct.imageMobile
          : cmsProduct.image
        : "";
    },
    getUserViewName(title, productType, cmsData) {
      const cmsProduct = cmsData.filter(
        (product) => product.productName == title
      )[0];
      return cmsProduct ? cmsProduct.displayName : "";
    },
    getUserViewDescription(title, productType, cmsData) {
      const cmsProduct = cmsData.filter(
        (product) => product.productName == title
      )[0];
      return cmsProduct ? cmsProduct.shortDescription : "";
    },
    getPrice(price) {
      return this.getPriceWithLocale(price);
    },
    async processUpgradeProd(product, productType) {
      const processedUpgradeProds = product.map((product) => {
        return {
          src: this.getImages(product.title || "", productType, this.addOnsCMS),
          id: (product.productVariants[0] || {}).id,
          tags: product.tags,
          sku: (product.productVariants[0] || {}).sku,
          variant: product.productVariants[0],
          title: product.title,
          titleView: this.getUserViewName(
            product.title || "",
            productType,
            this.addOnsCMS
          ),
          priceView: Number(
            (((product || {}).priceRange || {}).maxVariantPrice || {}).amount
          ),
          priceCompare: (((product || {}).variant || {}).compareAtPriceV2 || {})
            .amount,
          price: Number(
            (((product || {}).priceRange || {}).maxVariantPrice || {}).amount
          ),
          description: product.description,
        };
      });
      return processedUpgradeProds;
    },
    getUpgradeProds() {
      return (async () => {
        const { data } = await invokeShopifyQuery(itemFilterWithProdUpgrades());
        this.upgradeOptions = await this.processUpgradeProd(
          this.mapShopifyProducts(data),
          GIFT_ADDS
        );
      })();
    },
    async getAddonsContent() {
      try {
        const response = await butter(this.$config).content.retrieve(
          ["addons"],
          {
            locale: this.$i18n.locale,
            "fields.type1": "common",
          }
        );
        this.addOnsCMS = this.mapCMSAddons(response);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
